import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrikethrough = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 12a4 4 0 0 1 0 8H6" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 4,
			x2: 20,
			y1: 12,
			y2: 12
		})
	]
});
export default SvgStrikethrough;
